"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _errorPage = _interopRequireDefault(require("./../../../../error-views/errorPage"));

// import { useHistory } from 'react-router';
var FormView = function FormView(_ref) {
  var formDetail = _ref.formDetail,
      formType = _ref.formType,
      onCancel = _ref.onCancel,
      isFormVisible = _ref.isFormVisible;
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // const history = useHistory();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      formTitle = _useState4[0],
      setFormTitle = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedReason = _useState6[0],
      setSelectedReason = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      btn = _useState8[0],
      setBtn = _useState8[1];

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var initialFormValues = {
    wannaDrop: '',
    WhatsApp_Number: formDetail.WhatsApp_Number,
    Reason: formDetail.Reason,
    Calling_Number: formDetail.Calling_Number,
    Token_Number: formDetail.Token_Number,
    RM_Code: formDetail.RM_Code,
    Student_Name: formDetail.Student_Name,
    Date: formDetail.Date,
    CLreason: ''
  }; // useEffect(async()=>{
  //     if(formType==='Drop')
  //     {
  //       setFormTitle('Do You Want to Approve this Request');
  //       setSelectedReason('हाँ');
  //       setBtn('Droped')
  //     }
  //     else
  //     {
  //       setFormTitle('Do You Want to Reject this Request');
  //       setSelectedReason('नहीं');
  //       setBtn("Don't Droped")
  //     }
  //     form.setFieldsValue(initialFormValues);
  // },[formDetail]);

  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (formType === 'Drop') {
                  setFormTitle('Do You Want to Approve this Request');
                  setSelectedReason('हाँ');
                  setBtn('Droped');
                } else {
                  setFormTitle('Do You Want to Reject this Request');
                  setSelectedReason('नहीं');
                  setBtn("Don't Droped");
                }

                form.setFieldsValue(initialFormValues);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line
  }, [formDetail]);

  var MakeValid = function MakeValid() {
    var f1 = form.getFieldValue();
    var obj = {
      wannaDrop: selectedReason,
      WhatsApp_Number: formDetail.WhatsApp_Number,
      Reason: formDetail.Reason,
      Calling_Number: formDetail.Calling_Number,
      Token_Number: formDetail.Token_Number,
      RM_Code: formDetail.RM_Code,
      Student_Name: formDetail.Student_Name,
      Date: formDetail.Date,
      CLreason: f1.CLreason ? f1.CLreason : "No Reason"
    };
    var url = _config.default.updateDroppedStudent + cl + "&RMcode=" + formDetail.RM_Code;

    if (selectedReason === 'हाँ' && f1.CLreason === '') {
      alert('Please select a reason to drop');
      return;
    } else {
      _axios.default.post(url, obj, {
        headers: {
          'Authorization': token
        }
      }).then(function (response) {
        if (response.data.status === "error") setapiError(response.data);

        if (selectedReason === 'हाँ') {
          alert("Dropped Successfully");
          window.location = "/clPortal/app/parent/requests";
          onCancel();
        } else {
          alert("Drop Request Rejected Successfully");
          window.location = "/clPortal/app/parent/requests";
          onCancel();
        }
      }, function (error) {
        setapiError(error.response);
      });
    }
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: formTitle,
    visible: isFormVisible,
    onOk: MakeValid,
    onCancel: onCancel,
    okText: btn === 'Droped' ? "Droped" : "Don't Droped",
    okButtonProps: btn === "Droped" ? {
      style: {
        backgroundColor: 'red'
      }
    } : {
      style: {
        backgroundColor: 'green'
      }
    },
    cancelButtonProps: {
      style: {
        display: 'none'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    form: form,
    onFinish: MakeValid
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Token_Number",
    label: "Token No"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: formDetail.Token_Number,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Date",
    label: "Request Date"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: formDetail.Date,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Student_Name",
    label: "Student Name"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: formDetail.Student_Name,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "RM_Code",
    label: "RM Code"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: formDetail.RM_Code,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Calling_Number",
    label: "Calling Number"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: formDetail.Calling_Number,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "WhatsApp_Number",
    label: "WhatsApp Number"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: formDetail.WhatsApp_Number,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Reason",
    label: "RM's Reason"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: formDetail.Reason,
    disabled: true
  })), selectedReason === 'हाँ' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "CLreason",
    label: "Please Select a reason to drop"
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
    name: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092B\u093E\u092F\u0926\u093E \u0928\u0939\u0940\u0902 \u0926\u093F\u0916 \u0930\u0939\u093E \u0939\u0948"
  }, " \u092B\u093E\u092F\u0926\u093E \u0928\u0939\u0940\u0902 \u0926\u093F\u0916 \u0930\u0939\u093E \u0939\u0948"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092C\u091A\u094D\u091A\u0947 \u0915\u094B \u092A\u0938\u0902\u0926 \u0928\u0939\u0940 \u0906\u092F\u093E"
  }, "\u092C\u091A\u094D\u091A\u0947 \u0915\u094B \u092A\u0938\u0902\u0926 \u0928\u0939\u0940 \u0906\u092F\u093E"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092C\u091A\u094D\u091A\u0947 \u092F\u093E \u092E\u093E\u0901 \u0915\u0947 \u092A\u093E\u0938 \u0938\u092E\u092F \u0928\u0939\u0940\u0902 \u0939\u0948"
  }, "\u092C\u091A\u094D\u091A\u0947 \u092F\u093E \u092E\u093E\u0901 \u0915\u0947 \u092A\u093E\u0938 \u0938\u092E\u092F \u0928\u0939\u0940\u0902 \u0939\u0948"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0918\u0930 \u092C\u0926\u0932 \u0930\u0939\u093E \u0939\u0948, \u0935\u0939\u093E \u0938\u0941\u0935\u093F\u0927\u093E \u0928\u0939\u0940\u0902 \u0939\u0948"
  }, "\u0918\u0930 \u092C\u0926\u0932 \u0930\u0939\u093E \u0939\u0948, \u0935\u0939\u093E \u0938\u0941\u0935\u093F\u0927\u093E \u0928\u0939\u0940\u0902 \u0939\u0948"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "RM \u0915\u0947 \u091B\u094B\u0921\u093C\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u092C\u091A\u094D\u091A\u093E \u0921\u094D\u0930\u0949\u092A \u0939\u094B \u0917\u092F\u093E \u0939\u0948"
  }, "RM \u0915\u0947 \u091B\u094B\u0921\u093C\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u092C\u091A\u094D\u091A\u093E \u0921\u094D\u0930\u0949\u092A \u0939\u094B \u0917\u092F\u093E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0921\u0941\u092A\u094D\u0932\u093F\u0915\u0947\u091F"
  }, "\u0921\u0941\u092A\u094D\u0932\u093F\u0915\u0947\u091F"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092B\u094B\u0928 \u0959\u0930\u093E\u092C \u0939\u0948/\u092B\u094B\u0928 \u092E\u0947\u0902 \u0930\u093F\u091A\u093E\u0930\u094D\u091C \u0928\u0939\u0940\u0902 \u0939\u0948 "
  }, "\u092B\u094B\u0928 \u0959\u0930\u093E\u092C \u0939\u0948/\u092B\u094B\u0928 \u092E\u0947\u0902 \u0930\u093F\u091A\u093E\u0930\u094D\u091C \u0928\u0939\u0940\u0902 \u0939\u0948 \u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0938\u093E\u0930\u0940 \u0935\u0930\u094D\u0915\u0936\u0940\u091F \u0915\u092E\u094D\u092A\u0932\u0940\u091F \u0939\u094B \u0917\u0908 \u0939\u0948"
  }, "\u0938\u093E\u0930\u0940 \u0935\u0930\u094D\u0915\u0936\u0940\u091F \u0915\u092E\u094D\u092A\u0932\u0940\u091F \u0939\u094B \u0917\u0908 \u0939\u0948\u0964"))))) : null)));
};

var _default = FormView;
exports.default = _default;